define('models/PaymentMethodModel',[
    'underscore','backbone','ObjectModel','LocalStorage','app',
    'ApiRequest',
    'models/EdenredDataModel',
    'views/blocks/OgoneView',
    'views/blocks/OgoneDirectView',
    'views/blocks/InvoiceAddressSelectorView',
    'views/blocks/CashOnDeliveryView',
    'views/blocks/CBOnDeliveryView',
    'views/blocks/EdenredView'
],function (
        _,Backbone,ObjectModel,LocalStorage,app,
        ApiRequest,
        EdenredDataModel,
        OgoneView,
        OgoneDirectView,
        InvoiceAddressSelectorView,
        CashOnDeliveryView,
        CBOnDeliveryView,
        EdenredView
    ) {
    //
    // Model PaymentMethod
    //
    var PaymentMethodModelPrototype = {
        
        name:'PaymentMethodModel',
        route:'apiPaymentMethodModel',
        idAttribute:'id_payment_method',
        
        initialize:function(){
            var model = this;
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(model,arguments);
            //
            this.resetOptions();
        },

        multipleDisable:function () {
            var restriction_nbr = this.get('restriction_nbr');
            if (restriction_nbr && restriction_nbr > 1)
                return true;
            else
                return false;
        },
        disableProductGetName:function () {
            var restriction_product_name = this.get('restriction_product_name');
            if (restriction_product_name )
                return restriction_product_name;
            else
                return '';
        },
        getRestrictionMessage: function(cart){
            if(!cart){cart = app.getCart();}
              var paymentRestrictions = cart.get('payment_restrictions'),
                  restrictions = paymentRestrictions[this.id],
                  message = "", args;
            if(restrictions){
                args = app.getProduct(restrictions[0]).getName();
                if(restrictions.length>1){
                    message = "Plusieurs produits présents dans votre panier ne sont pas éligibles avec ce mode de paiment (%s, …)";
                }else if(restrictions){
                    message = "%s n’est pas éligible avec ce mode de paiment";
                }
            }
            if(EdenredDataModel.isActive() && !this.canUseInMultiPayment()){
                message += " Indisponible avec Edenred."
            }
            return app.t(message,'Checkout',args);
        },
        canUseInMultiPayment:function(){
            return this.get('can_use_in_multi_payment');
        },
        hasRestriction:function(cart){
            return this.hasProductRestriction() || this.hasMultipaymentRestriction();
        },
        hasProductRestriction:function(cart)
        {
            // teste si le mode de paiment à un restriction lié à un produit (du panier)
         if(!cart){cart = app.getCart();}
          var model = this,
              hasRestriction,
              paymentRestrictions = cart.get('payment_restrictions'),
              restriction = paymentRestrictions[model.id];

            hasRestriction = !_.isUndefined(restriction);

            return hasRestriction;
        },
        hasMultipaymentRestriction:function() {
            // teste si le mode de paiment à un restriction lié à un paiement multiple
            var model = this,
                hasMultipaiementRestriction = false,
                canUseInMultiPayment = model.canUseInMultiPayment();
            if(EdenredDataModel.isActive() && !canUseInMultiPayment){
                hasMultipaiementRestriction = true;
            }
            return hasMultipaiementRestriction;
        },
        resetOptions:function(){
            this.options = {id_payment_method:this.id,params:{}};
        },
        getModuleClass:function(){
            return this.get('class_payment_module');
        },
        load3DSv2Params:function(){
            // Ogone 3DS v2 extra params
            var navigator = window.navigator,
                screen = window.screen,
                extraParams = this.options.extraParams = {};
            //
            function setBrowserInfo(name,value){
                extraParams['browser'+name] = value;
            }
            try {
                setBrowserInfo('JavaEnabled', navigator.javaEnabled() || false);
                setBrowserInfo('TimeZone', new Date().getTimezoneOffset());
                setBrowserInfo('ColorDepth', screen.colorDepth);
                setBrowserInfo('Language', navigator.language);
                setBrowserInfo('ScreenWidth', screen.width);
                setBrowserInfo('ScreenHeight', screen.height);
                setBrowserInfo('UserAgent', navigator.userAgent);
            }catch(err){

            }
        },
        getName:function(){
            return this.get('name');
        },
        validateBeforeSubmit:function(callback){
            var validate = true, model = this;
            switch(this.getModuleClass()){
                case 'Ogone':
                    var validateCVC = false;
                    try{
                        validateCVC = !!model.options.params.cvc;
                    }catch(err){
                        app.error();
                    }
                    if(app.getCart().requireCVC() && !model.options.params.cvc){
                        app.alert({
                            title: app.t('Sécurité', 'UI'),
                            subtitle: app.t('Veuillez saisir le CVC de la carte','Payment'),
                            callback:function(){
                                callback(false);
                                app.trigger('CVCError');
                            }
                        });
                        validate = false;
                    }
                    break;
                case 'Paytabs':
                var primaryAddress = app.getCustomer().getPrimaryAddress();
                if(!primaryAddress){
                    var invoiceAddressView = new InvoiceAddressSelectorView({theme:'modal',type:'address',action:'invoice'});
                    app.displayModal(invoiceAddressView);
                    function invoiceCallback(address){
                        // si on a une adresse (success) on la convertie en boolean true
                        // sinon (cancel) en false
                        callback(!!address);
                    }
                    invoiceAddressView.once('success',invoiceCallback);
                    invoiceAddressView.once('cancel',invoiceCallback);
                    validate = false;
                }
                break;
            }
            return validate;
        },
        next:function(){
            alert(this.getModuleClass());
            var paymentMethod = this,
                viewOptions = {paymentMethod:paymentMethod},
                view;
            paymentMethod.resetOptions();

            switch(this.getModuleClass()){
                //
                case 'Edenred':
                    view = new EdenredView(viewOptions);
                    break;
                case 'CashOnDelivery':
                    paymentMethod.options.return_money = 0;
                    view = new CashOnDeliveryView(viewOptions);
                    break;
                case 'Ogone':
                    paymentMethod.load3DSv2Params();
                    view = new OgoneView(viewOptions);
                    break;
                case 'CBOnDelivery':
                    view = new CBOnDeliveryView(viewOptions);
                    break;
                default :
                    view = new Backbone.View(viewOptions);
            }
            app.trigger('displayCheckoutPaymentMethodOption',view);
        },
        getOptions:function(){
            var options = this.options;
            if(this.canUseInMultiPayment()){
                options.use_multiple_payment = EdenredDataModel.isActive();
                options.multiple_payment_available_amount = EdenredDataModel.getUsedAvailable();
                options.multiple_id_payment_method = EdenredDataModel.getPaymentMethod().id;
            }
            return options;
        }
    };

    var PaymentMethodModel = ObjectModel.extend(LocalStorage).extend(PaymentMethodModelPrototype);
    
    return PaymentMethodModel;
});
